module.exports = __webpack_public_path__ + "static/media/Get-more.58ab99e2.png";